<template>
  <section class="confirm__main">
    <section class="header">
      <h4>{{ $t("descriptions.selected_data") }}</h4>
      <small>{{ $t("descriptions.unit_profile_modification_info") }}</small>
    </section>

    <section class="data__contain">
      <section class="data__old">
        <span> {{ connectedUser.unity_name }}</span>
        <small>({{ connectedUser.profile }})</small>
      </section>

      <section class="icon__divider">
        <v-icon> mdi-arrow-down-thin-circle-outline </v-icon>
      </section>

      <section class="data__new">
        <span>{{ unityAndProfile.unity.name }}</span>
        <small>({{ unityAndProfile.profile.name }})</small>
      </section>
    </section>

    <Divider />

    <section class="confirm__password">
      <section>
        <h4>{{ $t("descriptions.pending_confirmation") }}</h4>
        <small>
          {{ $t("descriptions.confirm_completion_password_required") }}
        </small>
      </section>

      <v-text-field
        v-model="userPassword"
        :label="$t('inputs.password')"
        class="border__radius-10"
        placeholder="******"
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        @click:append="showPass = !showPass"
        hide-details
        outlined
        dense
      ></v-text-field>
    </section>

    <section class="buttons__actions__layout actions">
      <v-btn
        class="btn__default border__radius-10"
        type="submit"
        height="42"
        depressed
        :loading="isLoading"
        :disabled="isLoading"
        @click="goBack"
      >
        {{ $t("buttons.return") }}
      </v-btn>

      <v-btn
        class="btn__default border__radius-10"
        color="primary"
        type="submit"
        height="42"
        depressed
        :loading="isLoading"
        :disabled="!checkInputPassword || isLoading"
        @click="changeConnectedUserUnityProfile"
      >
        {{ $t("buttons.continue") }}
      </v-btn>
    </section>
  </section>
</template>

<script>
import Divider from "@/components/widgets/indicators/Divider.vue";
import { setLogin } from "@/services/users";
import { getConnectedUser } from "@/utils/localStorage";
import { mapActions } from "vuex";
import { BroadcastChannel } from "broadcast-channel";

export default {
  name: "ConfirmChangeComponent",

  props: {
    unityAndProfile: {
      type: Object,
    },
  },

  data: () => ({
    connectedUser: {},
    userPassword: "",
    showPass: false,
    isLoading: false,
  }),

  computed: {
    checkInputPassword() {
      return this.userPassword !== "" && this.userPassword.length > 3;
    },
  },

  components: { Divider },

  created() {
    this.connectedUser = getConnectedUser();
  },

  methods: {
    ...mapActions(["changeChangeUnityProfileStatus"]),

    goBack() {
      this.$emit("changeStep", 1);
    },

    async changeConnectedUserUnityProfile() {
      this.isLoading = true;
      const data = {
        cpf: this.connectedUser.cpf,
        password: this.userPassword,
        unity_id: this.unityAndProfile.unity.id,
        profile_id: this.unityAndProfile.profile.id,
      };

      const requestResponse = await setLogin(data);
      if (requestResponse.status) {
        this.$snackbar.setParams(
          "success",
          requestResponse.message,
          this.$t("messages.success_update")
        );

        setTimeout(() => {
          const channel = new BroadcastChannel("tabUpdateChannel");
          channel.postMessage("UPDATE!");
          channel.close();
        }, 2000);
      } else {
        this.$snackbar.setParams(
          "error",
          this.$t("messages.error_update"),
          requestResponse.message
        );

        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm__main {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;

  .header {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .data__contain {
    display: flex;
    flex-direction: column;
    gap: 3px;
    border-radius: 15px;
    font-weight: 500;
    text-align: center;

    span {
      font-weight: 600;
      font-size: 12px;
    }

    small {
      font-weight: 400;
      font-size: 11px;
    }

    .data__old {
      display: flex;
      flex-direction: column;
      background: #fafafa;
      padding: 15px 15px 20px 15px;
      border-radius: 15px;
    }

    .icon__divider {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 0;

      .v-icon {
        padding: 3px;
        background: #ffffff;
        border: 2px solid transparent;
        border-radius: 50%;
      }
    }

    .data__new {
      display: flex;
      flex-direction: column;
      background: #f1f9ff;
      color: #0e69aa;
      padding: 20px 15px 15px 15px;
      border-radius: 15px;
    }
  }

  .confirm__password {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .actions {
    display: flex;
    align-items: flex-end;
    height: 100%;
  }
}
</style>
